import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import PageLoader from '../ui/PageLoader';

// Persisted so the destination survives the FULL-PAGE reload the OAuth/demo
// login performs (state.from alone dies with the SPA document — M14).
export const REDIRECT_KEY = 'auth_redirect_path';

export const storeRedirectPath = (path) => {
    if (path && path.startsWith('/') && !path.startsWith('//')) {
        sessionStorage.setItem(REDIRECT_KEY, path);
    }
};

// Marker set while the OAuth callback page is resolving the token, so
// PublicLayout's "already signed in → /shelter" effect does not consume (and
// lose) the stored destination mid-callback.
const CALLBACK_KEY = 'auth_callback_pending';

export const markCallbackPending = () => sessionStorage.setItem(CALLBACK_KEY, '1');
export const clearCallbackPending = () => sessionStorage.removeItem(CALLBACK_KEY);

export const consumeRedirectPath = () => {
    // Never consume while the auth callback is still resolving (M14 race)
    if (sessionStorage.getItem(CALLBACK_KEY)) return null;
    const path = sessionStorage.getItem(REDIRECT_KEY);
    sessionStorage.removeItem(REDIRECT_KEY);
    // Only ever return local paths — never an off-site URL.
    return path && path.startsWith('/') && !path.startsWith('//') ? path : null;
};

export default function RequireAuth() {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-bg-darkest text-text-light">
                <PageLoader />
            </div>
        );
    }

    if (!isAuthenticated) {
        // Remember where the user was headed so login can send them back (M14):
        // in `state.from` for SPA navigations, in sessionStorage for the full-page
        // reload the OAuth redirect performs.
        storeRedirectPath(location.pathname + location.search);
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return <Outlet />;
}
